import TweenLite from 'gsap/TweenLite'
import CSSPlugin from 'gsap/CSSPlugin'

import CoreResize from '../../mixins/core-resize'

export default
{
    name: 'app-content-accordion',

    mixins:
    [
        CoreResize
    ],

    props:
    {
        part: { type: Object, default: {} },
        index: { type: Number, default: null }
    },

    data()
    {
        return {
            collapsed: true
        }
    },

    mounted()
    {
        this._height = this.$el.offsetHeight
        this.$el.classList.add('u-height-xxl')
    },

    methods:
    {
        _toggleCollapsed()
        {
            this.collapsed = !this.collapsed
            TweenLite.to(
                this.$el,
                0.5,
                {
                    height: this.collapsed ? 150 : this._height,
                    ease: 'Expo.easeInOut',
                    onComplete: () =>
                    {
                        this.$nextTick(() => this.$emit('resized', this))
                    }
                }
            )
        },

        onResized()
        {
            // Avoid warning
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-content-accordion/script.js